
import { isValidRateRange } from 'shared/lib/validators';
import { RATE_PERIOD, RATE_TYPE, DAYS_IN_MONTH } from 'shared/constants';

export const roundRate = rate => Math.round(rate); //  * 100) / 100;

export const calcMonthlyRate = (rate, ratePeriod) => {
  switch (ratePeriod) {
    case RATE_PERIOD.HOURLY:
      return roundRate(rate * 8 * DAYS_IN_MONTH);
    case RATE_PERIOD.DAILY:
      return roundRate(rate * DAYS_IN_MONTH);
    case RATE_PERIOD.MONTHLY:
      return roundRate(rate);
    case RATE_PERIOD.YEARLY:
      return roundRate(rate / 12);
    default:
      return roundRate(rate);
  }
};

export const monthlyRateFields = (rate, rateUpTo, rateType, ratePeriod) => {
  if (rateType === RATE_TYPE.UNPAID || ~~rate <= 0) {
    return {
      monthlyRate: 0,
      monthlyRateUpTo: 0
    };
  }

  const mr = calcMonthlyRate(~~rate, ~~ratePeriod);
  const mrUpTo = calcMonthlyRate(rateType === RATE_TYPE.RANGE ? ~~rateUpTo : ~~rate, ~~ratePeriod);

  return {
    monthlyRate: mr,
    monthlyRateUpTo: isValidRateRange(mr, mrUpTo) ? mrUpTo : mr
  };
};

export const buildMonthlyRates = (employmentTypes = [], exchangeRates) => {
  const employmentTypesCurrencies = (employmentTypes || [])
    .map(employment => ({
      ...employment,
      ...monthlyRateFields(employment.rate, employment.rateUpTo, employment.rateType, employment.ratePeriod)
    }))
    .reduce((employments, employment) =>
      employments.concat(exchangeRates[employment.currency].map(currency => ({
        monthlyRate: roundRate(employment.monthlyRate * currency.rate),
        monthlyRateUpTo: roundRate(employment.monthlyRateUpTo * currency.rate),
        currency: currency.code,
      }))), []);

  return {
    monthlyRate: employmentTypesCurrencies.reduce((acc, curr) => {
      const currency = curr.currency.toLowerCase();
      const amount = curr.monthlyRate;
      if (!acc[currency] || acc[currency] < amount) {
        acc[currency] = amount;
      }

      return acc;
    }, {}),

    monthlyRateUpTo: employmentTypesCurrencies.reduce((acc, curr) => {
      const currency = curr.currency.toLowerCase();
      const amount = curr.monthlyRateUpTo;
      if (!acc[currency] || acc[currency] < amount) {
        acc[currency] = amount;
      }

      return acc;
    }, {})
  };
};
